import { inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LocalStorageService } from '../shared/services/ecommerce/localstorage.service';

@Injectable({
	providedIn: 'root'
})
export class Paso2Guard implements CanActivate {
	private localStorageService = inject(LocalStorageService);
	constructor(private router: Router) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const datosBusqueda = this.localStorageService.getItemByIndex('busqueda', 0);
		const itinerarioIda = this.localStorageService.getItemByIndex('itinerarioIda', 0);
		const itinerarioVuelta = this.localStorageService.getItemByIndex('itinerarioVuelta', 0);
		const { url_amigable, fecha_ida } = datosBusqueda;
		const paramIda = route.paramMap.get('tramo');

		if (!datosBusqueda) {
			this.router.navigate(['/']);
			return false;
		}

		if (!itinerarioIda && paramIda === 'ida') {
			this.router.navigate([`/pasajes-en-bus/paso1/${url_amigable}/${fecha_ida}/ida`]);
			return false;
		}

		if ((!itinerarioIda || !itinerarioVuelta) && paramIda === 'vuelta') {
			this.router.navigate([`/pasajes-en-bus/paso1/${url_amigable}/${fecha_ida}/ida`]);
			return false;
		}

		return true;
	}
}
